'use strict';

module.exports = require('./is-implemented')() ? Map : require('./polyfill');



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/es6-map/index.js
// module id = ../../../../es6-map/index.js
// module chunks = 4